import config from './config';

const JAWG_ATTRIB =
    '&copy; <a href="https://www.jawg.io" target="_blank">Jawg</a> - <a href="https://www.openstreetmap.org" target="_blank">&copy; OpenStreetMap</a> contributors';

/** Jawg raster tile URL; `styleId` is a preset (e.g. jawg-light) or a style id from Jawg Lab. */
function jawgRasterUrl(styleId) {
    const token = encodeURIComponent(config.JAWG_ACCESS_TOKEN);
    return `https://tile.jawg.io/${styleId}/{z}/{x}/{y}{r}.png?access-token=${token}`;
}

const baseLayerOptions = {
    'JawgLight': {
        id: 101,
        name: "Base Map",
        url: jawgRasterUrl(config.JAWG_LIGHT_STYLE_ID),
        attribution: JAWG_ATTRIB,
        max_zoom: 22,
        max_native_zoom: 22
    },
    'JawgDark': {
        url: jawgRasterUrl('jawg-dark'),
        attribution: JAWG_ATTRIB,
        maxZoom: 22,
        maxNativeZoom: 20
    },
    'JawgSunny': {
        url: jawgRasterUrl('jawg-sunny'),
        attribution: JAWG_ATTRIB,
        maxZoom: 22,
        maxNativeZoom: 20
    },
    'JawgStreet': {
        url: jawgRasterUrl('jawg-streets'),
        attribution: JAWG_ATTRIB,
        maxZoom: 22,
        maxNativeZoom: 20
    },
    'JawgTerrain': {
        url: jawgRasterUrl('jawg-terrain'),
        attribution: JAWG_ATTRIB,
        maxZoom: 22,
        maxNativeZoom: 20
    },
    'OpenStreetMapStreet': {
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        maxZoom: 19,
        subdomains: ['a', 'b', 'c']
    },
    'OpenStreetMapTerrain': {
        url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
        attribution: 'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (CC-BY-SA)',
        maxZoom: 17,
        subdomains: ['a', 'b', 'c']
    },
    "GoogleMap" : {
        name: "Google Map",
        url: `https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&key=${config.GOOGLE_MAPS_API_KEY}`,
        attribution: '&copy; <a href="https://maps.google.com">Google</a>',
        max_zoom: 22,
        max_native_zoom: 22
      }

};

export default baseLayerOptions;
